import { render, staticRenderFns } from "./SopClipboardView.vue?vue&type=template&id=17fba89a&scoped=true&"
import script from "./SopClipboardView.vue?vue&type=script&lang=ts&"
export * from "./SopClipboardView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fba89a",
  null
  
)

export default component.exports